<div class="manual-root">
    <!-- 上部バー -->
    <header class="manual-topbar">
        <a class="brand" [routerLink]="backLink()">
            <i class="icon-book-open"></i>
            <span>ロータス・リアルタイム実績管理システム</span>
        </a>
        <span class="topbar-title">{{ title }}</span>
        <span class="badge" [class.badge-pub]="isPublic">{{ subtitle }}</span>
        <span class="spacer"></span>
        <button *ngIf="toc.length" class="toc-toggle" type="button" (click)="tocOpen = !tocOpen" aria-label="目次">
            <i class="icon-list"></i> 目次
        </button>
        <a class="back" [routerLink]="backLink()">{{ isPublic ? 'ログイン画面へ' : 'システムに戻る' }}</a>
    </header>

    <div class="manual-shell">
        <!-- 目次 -->
        <nav class="manual-toc" [class.open]="tocOpen" *ngIf="toc.length">
            <div class="toc-head">目次</div>
            <ul>
                <li *ngFor="let item of toc" [class.lv3]="item.level === 3">
                    <a href="javascript:void(0)" [class.active]="activeId === item.id"
                       (click)="scrollTo(item.id, $event)">{{ item.text }}</a>
                </li>
            </ul>
        </nav>

        <!-- 本文 -->
        <main class="manual-content">
            <div *ngIf="loading" class="manual-state text-muted">読み込んでいます…</div>
            <div *ngIf="error" class="manual-state text-danger">マニュアルを読み込めませんでした。</div>
            <article #body class="manual-body" *ngIf="!loading && !error" [innerHTML]="html"></article>
        </main>
    </div>
</div>
